import React, { Component } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';

class OrderHeader extends Component {

  constructor (props) {
    super(props);

    this.state = {};
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  render () {
    const {simple} = this.props;
    return (
      <View
        style={styles.header}>
        <View
          style={[
            styles.column, {
              flex: 2,
            }]}>
          <Text
            style={styles.columnText}>
            Email
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            Điện thoại
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            Trạng thái
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            Hoa hồng
          </Text>
        </View>
        {!simple && Platform.OS === 'web' &&
        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            Vận đơn
          </Text>
        </View>}
        {!simple && Platform.OS === 'web' &&
        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            Mã kích hoạt
          </Text>
        </View>
        }
      </View>

    );
  }
}

const styles = StyleSheet.create({
  header: {
    height: 56,
    flexDirection: 'row',
    backgroundColor: '#6b7adc',
  },
  column: {
    flex: 1,
    marginLeft: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  columnText: {
    padding: 0,
    color: '#ffffff',
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
});

export default OrderHeader;



// WEBPACK FOOTER //
// ./src/item/OrderHeader.js